<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="推送类型" prop="type">
                <a-select style="width: 100%" v-model="queryParam.type" placeholder="请选择类型" allow-clear>
                  <a-select-option v-for="(item, index) in this.customDict.PushNoticeTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="跳转类型" prop="jumpType">
                <a-select style="width: 100%" v-model="queryParam.jumpType" placeholder="请选择跳转类型" allow-clear>
                  <a-select-option v-for="(item, index) in this.customDict.PushNoticeJumpTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="关联id" prop="relationId">-->
              <!--                  <a-input v-model="queryParam.relationId" placeholder="请输入关联id" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <a-col :md="8" :sm="24">
                <a-form-item label="推送标题" prop="title">
                  <a-input v-model="queryParam.title" placeholder="请输入推送标题" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="推送时间" prop="pushTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.pushTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:push/notice:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['system:push/notice:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:push/notice:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['system:push/notice:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="type" slot-scope="text, record">
          <!-- 重写自定义了个字典组件（标签）-->
          <custom-dict-tag :options="customDict.PushNoticeTypeEnum" :value="record.type" />
        </span>
        <span slot="jumpType" slot-scope="text, record">
          <!-- 重写自定义了个字典组件（标签）-->
          <custom-dict-tag :options="customDict.PushNoticeJumpTypeEnum" :value="record.jumpType" />
        </span>
        <template slot="smallIcon" slot-scope="text, record">
          <img v-if="record.smallIcon" :src="record.smallIcon + '?x-oss-process=image/format,png'" style="width:60px;height:60px;cursor: pointer;" preview alt=""/>
        </template>
        <template slot="largeIcon" slot-scope="text, record">
          <img v-if="record.largeIcon" :src="record.largeIcon + '?x-oss-process=image/format,png'" style="width:60px;height:60px;cursor: pointer;" preview alt=""/>
        </template>
        <span slot="pushTime" slot-scope="text, record">
          {{ parseTime(record.pushTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <template v-if="record.type === 1 || record.type === 3 || record.type === 4 || record.type === 5">
            <a @click="pushNow(record)" v-hasPermi="['system:push/notice:edit']" >
              <a-icon type="edit" />立即推送
            </a>
            <a-divider type="vertical" v-hasPermi="['system:push/notice:edit']" />
            <br/>
          </template>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:push/notice:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['system:push/notice:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['system:push/notice:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listPushNotice, delPushNotice, pushNow } from '@/api/system/pushNotice'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag/index.vue'

export default {
  name: 'PushNotice',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        type: undefined,
        jumpType: undefined,
        relationId: null,
        title: null,
        content: null,
        smallIcon: null,
        largeIcon: null,
        pushTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '推送类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          ellipsis: true,
          width: 130,
          align: 'center'
        },
        {
          title: '跳转类型',
          dataIndex: 'jumpType',
          scopedSlots: { customRender: 'jumpType' },
          ellipsis: true,
          width: 85,
          align: 'center'
        },
        // {
        //   title: '关联id',
        //   dataIndex: 'relationId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '推送标题',
          dataIndex: 'title',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '推送内容',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '右侧图标',
          dataIndex: 'smallIcon',
          scopedSlots: { customRender: 'smallIcon' },
          ellipsis: true,
          width: 85,
          align: 'center'
        },
        {
          title: '大图标',
          dataIndex: 'largeIcon',
          scopedSlots: { customRender: 'largeIcon' },
          ellipsis: true,
          width: 85,
          align: 'center'
        },
        {
          title: '推送时间',
          dataIndex: 'pushTime',
          scopedSlots: { customRender: 'pushTime' },
          ellipsis: true,
          width: 160,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 160,
          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '13%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: { ...mapGetters(['customDict']) },
  watch: {
  },
  methods: {
    /** 查询推送通知管理列表 */
    getList () {
      this.loading = true
      listPushNotice(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        type: undefined,
        jumpType: undefined,
        relationId: undefined,
        title: undefined,
        content: undefined,
        smallIcon: undefined,
        largeIcon: undefined,
        pushTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delPushNotice(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('system/push/notice/export', {
            ...that.queryParam
          }, `push/notice_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 立即推送按钮操作 */
    pushNow(row) {
      const that = this
      this.$confirm({
        title: '是否确定推送?',
        content: '此操作将立即推送<' + row.title + '>消息',
        onOk () {
          return pushNow(row.id).then(() => {
              that.$message.success(
                '推送成功',
                3
              )
            }).catch(e => {
              that.$message.error('推送消息失败' + e)
          })
        },
        onCancel () {}
      })
    }
  }
}
</script>
